import {
	ConsultRefundProtocolStatusData,
	REFUND_PROTOCOL_STATUS,
} from 'domain/usecases/private/refund/consult-refunds/get-refund-protocol-status';
import {PortalTimelineProps} from 'presentation/components/Timeline/types';
import {translations} from 'presentation/translations-new';
import {dateTimeHandle} from 'presentation/utils/dateTimeHandle';
import {RefundStatusDrawerData} from './types';
import {refundProtocolStatusParser} from './refundProtocolStatusParser';

const {updatedLatestAt} = translations['pt-br'].commons;

export function consultRefundProtocolStatus(data: ConsultRefundProtocolStatusData) {
	return {
		parseDataToTimeline(): PortalTimelineProps['content'] {
			const {situationHistories} = data;

			if (!situationHistories || !situationHistories.length) {
				return [];
			}

			return situationHistories.map(status => ({
				title: refundProtocolStatusParser(status.situationCode, REFUND_PROTOCOL_STATUS),
				description: dateTimeHandle.fromDateAndTimeString(status.situationAt),
			}));
		},
		drawerData(): RefundStatusDrawerData {
			const parsedDataToTimeline = consultRefundProtocolStatus(data).parseDataToTimeline();

			if (!parsedDataToTimeline || !parsedDataToTimeline.length) {
				return {
					subtitle: '',
					data: [],
				};
			}

			const {description} = parsedDataToTimeline[0];
			const subtitle = `${updatedLatestAt}: ${description}`;
			return {
				subtitle,
				data: parsedDataToTimeline,
			};
		},
	};
}
